import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import {Route, Redirect} from 'react-router-dom';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

class AuthLayout extends Component {
    //access router
    //this.props.history.push('/dashboard')

    render() {
        const {authenticated, component: Component, ...rest} = this.props
        return (
            <Route {...rest} render={props => !authenticated ? 
                <Component {...props} />
                : <Redirect to='/' />} />
        )
    }
}

AuthLayout.propTypes = {
    //history: PropTypes.shape({
    //    push: PropTypes.func.isRequired
    //}).isRequired,
    component: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    location: PropTypes.object
};

function mapStateToProps(state) {
    return {
        isAuthenticated: state.auth.authenticated
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthLayout)


// WEBPACK FOOTER //
// ./src/routes/Auth.js